import { VideoDialogState } from "../../reducers/components/VideoDialogReducer";

export type VideoDialogAction =
  | {
      type: "DISPLAY_VIDEO_DIALOG";
      payload: VideoDialogState;
    }
  | {
      type: "CLOSE_VIDEO_DIALOG";
      payload: [];
    };

function openVideoDialog(
  title: string,
  message: string,
  btnOnetext: string,
  btnOneOnclick: any,
  onReady: any,
  src: string
): VideoDialogAction {
  return {
    type: "DISPLAY_VIDEO_DIALOG",
    payload: {
      title: title,
      message: message ,
      btnOnetext: btnOnetext,
      btnOneOnclick: btnOneOnclick,
      onReady: onReady,
      open: false,
      src: src
    },
  };
}

function closeVideoDialog(): VideoDialogAction {
  return { type: "CLOSE_VIDEO_DIALOG", payload: [] };
}

export const VideoDialogActions = {
  openVideoDialog,
  closeVideoDialog,
};
